import React from "react";
import { Breadcrumbs, Link, Typography, Box } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useNavigate } from "react-router-dom";

export default function BreadcrumbsBar({ breadcrumbs }) {
  const navigate = useNavigate();

  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <Box
      sx={{
        mb: 2.5,
        px: 0.5,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        flex: "1 1 0%",
        boxSizing: "border-box",
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <NavigateBeforeIcon
            sx={{
              fontSize: "0.8rem",
              display: "block",
              width: "max-content",
              maxWidth: "none",
              "& .MuiBreadcrumbs-ol": {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                width: "max-content",
                margin: 0,
                padding: 0,
              },
              "& .MuiBreadcrumbs-li": {
                whiteSpace: "nowrap",
                flexShrink: 0,
              },
            }}
          />
        }
        sx={{
          fontSize: "0.8rem",
          width: "max-content",
          minWidth: "100%",
          "& .MuiBreadcrumbs-ol": {
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center",
            width: "max-content",
            minWidth: "100%",
          },
          "& .MuiBreadcrumbs-li": {
            whiteSpace: "nowrap",
            minWidth: 0,
            flexShrink: 0,
          },
        }}
      >
        {breadcrumbs.map((b, index) => {
          const isLast = index === breadcrumbs.length - 1;

          if (isLast) {
            return (
              <Typography
                key={b.id}
                color="text.primary"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.8rem",
                  maxWidth: { xs: "100%", sm: 360, md: 480 },
                  minWidth: 0,
                  whiteSpace: "normal",
                  overflowWrap: "anywhere",
                  wordBreak: "normal",
                  lineHeight: 1.6,
                  flexShrink: 1,
                }}
              >
                {b.title}
              </Typography>
            );
          }

          const handleClick = () => {
            if (b.id === "home") {
              navigate("/");
            } else if (b.slug) {
              navigate(`/category/${b.slug}`);
            }
          };

          return (
            <Link
              key={b.id}
              underline="hover"
              color="text.secondary"
              sx={{
                cursor: "pointer",
                fontWeight: 500,
                fontSize: "0.8rem",
                transition: "color 0.2s",
                maxWidth: { xs: 120, sm: 220, md: 280 },
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "inline-block",
                verticalAlign: "middle",
                "&:hover": { color: "primary.main" },
              }}
              onClick={handleClick}
            >
              {b.title}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}
